import { isStringEmpty } from "../../../utils/handler_validations";
import styles from "./styles";
import logo from "../../../assets/logos/very-yellow-icon-01.png";
import { VeryBtnTransparent } from "../v2/VeryBtnTransparent";
import { classVeryBtnTransparent } from "../v2/VeryBtnTransparent/classVeryBtnTransparent";
import { useEffect, useState } from "react";
import { DivLoading } from "../DivLoading";
import { VeryBtnFill } from "../v2/VeryBtnFill";
import { classVeryBtnFill } from "../v2/VeryBtnFill/classVeryBtnFill";
import { createRef } from "react";

const propsTemplate = () => ({
  reff: createRef(),
  isLoading: false,
  error: { message: "", details: "" },
  onClickBtnRetry: () => {},
});

export const DivContentPage = (props = propsTemplate()) => {
  const [showModalError, setShowModalError] = useState(false);

  useEffect(() => {
    setShowModalError(false);
  }, [props.error]);

  return (
    <>
      <styles.DivMain className={props.className} ref={props.reff}>
        {props.isLoading ? (
          <DivLoading size={90} weight={5} />
        ) : !isStringEmpty(props.error?.message) ? (
          <div className="divError">
            <img src={logo} />
            <label className="txtMessage">{props.error.message}</label>
            <div className="divButtons">
              <VeryBtnTransparent
                CSS={["btnMoreInfo"]}
                colorTheme={classVeryBtnTransparent.COLOR_THEME.BLACK_S1}
                label="Más información"
                textSize={13}
                onClick={() => setShowModalError(true)}
              />
              <VeryBtnFill
                CSS={["btnRetry"]}
                colorTheme={classVeryBtnFill.COLOR_THEME.BLACK_S1}
                label="Reintentar"
                textSize={14}
                onClick={props.onClickBtnRetry}
              />
            </div>
          </div>
        ) : (
          props.children
        )}
      </styles.DivMain>

      {/* MODAL ERROR */}
      <styles.ModalError
        isVisible={showModalError}
        title="Detalles del error"
        onClickClose={() => setShowModalError(false)}
      >
        <label className="txtError">
          {isStringEmpty(props.error?.details)
            ? "Lo sentimos no hay detalles de este error"
            : props.error.details}
        </label>
      </styles.ModalError>
    </>
  );
};
